import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import {
    SubdomainConfigForm,
    SubdomainConfigResponse,
} from "@convin/type/SubdomainConfig";

const SUBDOMAIN_CONFIG_URL = "/app/internal_tools/subdomain_config/";

export const subdomainConfigApiSlice = createApi({
    reducerPath: "subdomainConfigApiSlice",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["SubdomainConfig"],
    endpoints: (builder) => ({
        getSubdomainConfig: builder.query<SubdomainConfigResponse, void>({
            query: () => ({
                url: SUBDOMAIN_CONFIG_URL,
                method: "GET",
            }),
            providesTags: ["SubdomainConfig"],
        }),
        updateSubdomainConfig: builder.mutation<
            SubdomainConfigResponse,
            SubdomainConfigForm
        >({
            query: (form) => ({
                url: SUBDOMAIN_CONFIG_URL,
                method: "PUT",
                body: form,
            }),
            invalidatesTags: ["SubdomainConfig"],
        }),
    }),
});

export const { useGetSubdomainConfigQuery, useUpdateSubdomainConfigMutation } =
    subdomainConfigApiSlice;
